var selectors = {
	insightsDefaultHeader:'.js-insights-default-header',
	insightsSearchResultsHeader: '.js-insights-search-results-header',
	insightsSearchFilter: '.js-insights-search-filter',
}

var module = {
	init: function () {
		let lastUrl = location.href;
		let debounceTimer;

		// Check if the query string is present on page load
		module._handleQueryStringChange();

		const observer = new MutationObserver(() => {
			if (location.href !== lastUrl) {
				clearTimeout(debounceTimer);
				debounceTimer = setTimeout(() => {
					lastUrl = location.href;
					this._handleQueryStringChange(new URL(location.href).searchParams);
				}, 100);
			}
		});

		observer.observe(document, { subtree: true, childList: true });
	},


	_getQueryParameter(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	},

	_handleQueryStringChange(searchParams) {
		let newInsightsQuery;

		newInsightsQuery = this._getQueryParameter('insightsQuery');

		module._changeQueryStringBlockText(newInsightsQuery);
		module._togglePageHeader(newInsightsQuery);
	},

	_changeQueryStringBlockText(keyword) {
		// Change the text of the query string block (a href element)
		const queryStringBlock = document.querySelector('.js-insights-search-query');
		queryStringBlock.textContent = keyword;
	},

	_togglePageHeader(query) {

		if (query) { // if there is query string, show search result header
			document.querySelector(selectors.insightsDefaultHeader).classList.add('is-hidden');
			document.querySelector(selectors.insightsSearchFilter).classList.add('is-hidden');
			document.querySelector(selectors.insightsSearchResultsHeader).classList.remove('is-hidden');
		} else { // if there is no query string, show default header
			document.querySelector(selectors.insightsDefaultHeader).classList.remove('is-hidden');
			document.querySelector(selectors.insightsSearchFilter).classList.remove('is-hidden');
			document.querySelector(selectors.insightsSearchResultsHeader).classList.add('is-hidden');
		}
	}
};

export { module as insightsSearch };
